import { AfterViewInit, Component, Input } from '@angular/core';
import { ConfigProvider } from '../../../config-provider.service';
import { NgOptimizedImage } from "@angular/common";

@Component({
  selector: 'full-screen-loader',
  providers: [],
  styleUrls: ['./full-screen-loader.scss'],
  standalone: true,
  imports: [
    NgOptimizedImage
  ],
  templateUrl: './full-screen-loader.html'
})
export class FullScreenLoaderComponent implements AfterViewInit {
    @Input() public progress = 0;
    @Input() public indeterminate = true;
    @Input() public message = 'Loading';
    constructor(
      public config: ConfigProvider,
    ) {
    }

    public ngAfterViewInit() {
    }
}
